import React from 'react';
import { connect } from 'react-redux';
import { Tabs, Tab } from 'react-bootstrap';

import DiffView from './DiffView';
import XmlView from './XmlView';
import Loading from './Loading';

const mapStateToProps = (state) => ({
  siteId: state.siteId,
  sourceRevisionCurrent: state.sourceRevision,
  targetRevisionCurrent: state.targetRevision,
  sourceXml: state.xmlSourceFile,
  targetXml: state.xmlTargetFile,
  xmlTargetFetchIsLoading: state.xmlTargetFetchIsLoading,
  xmlSourceFetchIsLoading: state.xmlSourceFetchIsLoading,
  showDiffContext: state.diffContextDisplay,
  folder: state.openedFolder,
  file: state.openedFile,
});

const mapDispatchToProps = () => ({});

class TabView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { key: 'diff' };
  }

  handleTabSelect(key) {
    this.setState({ key });
    if (key === 'source') this.props.scrollToActiveRev(this.props.sourceRevisionCurrent);
    else if (key === 'target') this.props.scrollToActiveRev(this.props.targetRevisionCurrent);
  }

  render() {
    if ((this.props.xmlSourceFetchIsLoading || this.props.xmlTargetFetchIsLoading) && this.props.targetRevisionCurrent !== 0) {
      return (<Loading />);
    }
    return (
      <div className="h100">
        {this.props.sourceRevisionCurrent !== 0 && (
          <Tabs activeKey={this.state.key} onSelect={(key) => this.handleTabSelect(key)} id="tabView">
            <Tab eventKey="diff" title="Diff">
              <DiffView
                source={this.props.targetXml}
                target={this.props.sourceXml}
                showContext={this.props.showDiffContext}
                folder={this.props.folder}
                callDVS={this.props.callDVS}
              />
            </Tab>
            <Tab eventKey="source" title={'Rev #' + this.props.sourceRevisionCurrent}>
              <XmlView
                callDVS={this.props.callDVS}
                resId={this.props.siteId}
                resNumber={this.props.sourceRevisionCurrent}
                resFolder={this.props.folder}
                resFile={this.props.file}
                xml={this.props.sourceXml}
              />
            </Tab>
            {this.props.targetRevisionCurrent !== 0 && (
              <Tab eventKey="target" title={'Rev #' + this.props.targetRevisionCurrent}>
                <XmlView
                  callDVS={this.props.callDVS}
                  resId={this.props.siteId}
                  resNumber={this.props.targetRevisionCurrent}
                  resFolder={this.props.folder}
                  resFile={this.props.file}
                  xml={this.props.targetXml}
                />
              </Tab>
            )}
          </Tabs>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TabView);
